import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import { Typography, Paper, Link } from "@mui/material";
import { getStyled, SFLoadingButton } from "@sf-core";
import { useTranslation, Trans } from "react-i18next";
import PropTypes from "prop-types";
import { ReactComponent as EyLogo } from "./images/logo.svg";
import env from "../../env.js";

const { styled } = getStyled();

const Item = styled(Paper)(({ theme }) => ({
  textAlign: "center",
}));

const LinkText = (props) => (
  <Link variant="blue" href={props.href || null} to={props.to || null}>
    {props.text}
  </Link>
);

const SigninForm = ({ onClick }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  return (
    <Stack spacing={2} sx={{ width: "90%" }}>
      <Item elevation={0}>
        <EyLogo />
      </Item>
      <Item elevation={0}>
        <Typography
          variant="h1"
          sx={{
            color: "#3A3A4A",
            fontSize: 28,
          }}
        >
          {t("signinScreen.welcome")}
        </Typography>
      </Item>
      <Item elevation={0}>
        <SFLoadingButton
          sx={{ width: "70%" }}
          onClick={() => {
            setLoading(true);
            onClick();
          }}
          loading={loading}
        >
          {t("signinScreen.signInButton")}
        </SFLoadingButton>
      </Item>
      <Item elevation={0}>
        <Typography variant="body1">
          <Trans
            i18nKey="signinScreen.unauthorized.support"
            t={t}
            values={{ supportMail: env.REACT_APP_SUPPORT_EMAIL }}
            components={{ link: <LinkText /> }}
          />
        </Typography>
      </Item>
    </Stack>
  );
};

SigninForm.propTypes = {
  onClick: PropTypes.func.isRequired,
};
export default SigninForm;
